export default __webpack_public_path__ + "static/media/Set's Potency.c2ff9c0d.jpg";